<div *ngFor="let langCode of getLangCodes()" [formGroup]="form">
  <!-- <span class="padded-bottom">
            {{ getNameByCode(langCode) | titlecase }}</span
          > -->
  <div [formGroupName]="langCode" class="in-two-columns">
    <mat-form-field>
      <app-easy-input
        [label]="'SHARED.LOCALIZED_TOURISM_SERVICE_SUBFORM.TITLE' | translate"
        formControlName="title"
      ></app-easy-input>
    </mat-form-field>
    <mat-form-field>
      <app-easy-textarea
        formControlName="description"
        [label]="
          'SHARED.LOCALIZED_TOURISM_SERVICE_SUBFORM.DESCRIPTION' | translate
        "
        [rows]="3"
        [resizable]="false"
      ></app-easy-textarea>
    </mat-form-field>
    <!-- tourismServicePictureId should be added later in the form of an image picker -->
    <!-- <mat-form-field appearance="outline">
              <input matInput formControlName="tourismServicePictureId" />
              <mat-hint>{{ "REQUIRED" | translate }}</mat-hint>
            </mat-form-field> -->
  </div>
</div>
